import { render, staticRenderFns } from "./RecipeItemAssociation.vue?vue&type=template&id=6a727ed0&"
import script from "./RecipeItemAssociation.vue?vue&type=script&lang=js&"
export * from "./RecipeItemAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports